import HomePage from "../components/HomePage";
import Profile from "../components/Profile";
import { userRoles as ur } from "../data/userRole";
export const general_routes = [
    {
        path: "/HomePage",
        ele: <HomePage />,
        availability: [ur.frontdesk, ur.admin, ur.dispatcher, ur.qa, ur.superAdmin, ur.customer, ur.dataProcess]
    },
    {
        path: "/profile",
        ele: <Profile />,
        availability: [ur.frontdesk, ur.admin, ur.dispatcher, ur.qa, ur.superAdmin, ur.customer, ur.dataProcess]
    },
]